import { QuizIcon, QuizOutline } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Quiz];

const config: ContentConfigProps = {
  routes: {
    create: routes.QuizCreator,
    edit: routes.QuizEditor,
    details: routes.QuizDetails,
    manageDetails: routes.AdminQuizDetails,
  },
  label: { title, createDescription },
  icons: {
    Create: QuizOutline,
    Icon: QuizIcon,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
